export const SET_QUESTIONS = "SET_QUESTIONS";
export const SET_USER_ANSWER = "SET_USER_ANSWER";
export const SET_QUESTION_COUNT = "SET_QUESTION_COUNT";